<template>
    <div>

        <div class="mb-4">
            <div class="d-flex justify-content-between text-align-center">
                <BButtonGroup>
                    <BButton variant="primary" @click="filterActive = !filterActive">
                        <i class="fad fa-filter mr-2"/> <span class="font-weight-500">Filtr</span>
                    </BButton>
                    <BButton
                        variant="danger"
                        @click="resetFilters"
                        v-if="isFilterUsed"
                    >
                        <i class="fad fa-times"/>
                    </BButton>
                </BButtonGroup>
            </div>

            <BCollapse :visible="filterActive || isFilterUsed" class="mt-4 bg-little-gray p-4">
                <BRow>
                    <BCol>
                        <BFormGroup
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Název:"
                            label-align-sm="right"
                            label-class="font-weight-700 m"
                            label-for="filter-name"
                            class="mb-0"
                        >
                            <BFormInput
                                id="filter-name"
                                v-model="filterRequest.filter.name"
                                size="sm"
                                @change="filterUpdated"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Typ opravy:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-type"
                            class="mb-0"
                        >
                            <BFormSelect
                                size="sm"
                                value-field="id"
                                text-field="text"
                                v-model="filterRequest.filter.type"
                                :options="typeOfRepairType.list()"
                                id="filter-type"
                                @change="filterUpdated"
                            >
                                <template #first>
                                    <BFormSelectOption :value="null">-- Vybrat --</BFormSelectOption>
                                </template>
                            </BFormSelect>
                        </BFormGroup>
                    </BCol>
                    <BCol>
                        <BFormGroup
                            label-size="sm"
                            label-cols-sm="5"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label="Komodita:"
                            label-align-sm="right"
                            label-class="font-weight-700"
                            label-for="filter-commodity"
                            class="mb-0"
                        >
                            <BFormSelect
                                size="sm"
                                value-field="id"
                                text-field="text"
                                v-model="filterRequest.filter.commodity"
                                :options="commodity.list()"
                                id="filter-commodity"
                                @change="filterUpdated"
                            >
                                <template #first>
                                    <BFormSelectOption :value="null">-- Vybrat --</BFormSelectOption>
                                </template>
                            </BFormSelect>
                        </BFormGroup>
                    </BCol>
                </BRow>
            </BCollapse>

        </div>

        <BTable
            ref="table"
            :fields="fields"
            :busy="isLoading"
            :current-page.sync="filterRequest.currentPage"
            :per-page.sync="filterRequest.perPage"
            :sort-by.sync="filterRequest.sortBy"
            :sort-desc.sync="filterRequest.sortDesc"
            :items="myProvider"
            tbody-tr-class="border-bottom"
            thead-tr-class="border-bottom"
            hover
            sort-icon-left
            borderless
            class="mb-0"
            show-empty>
            <template v-slot:table-busy>
                <TableLoading/>
            </template>
            <template v-slot:empty>
                <TableWithoutRecords/>
            </template>
            <template v-slot:cell(action)="data">
                <RouterLink
                    :to="{name: 'setup_repair_type_edit', params: {id: data.item.id}}"
                    class="btn btn-primary btn-sm"
                >
                    <i class="fad fa-pencil"/>
                </RouterLink>
            </template>
            <template v-slot:cell(active)="data">
                <span v-bind:class="data.item.active === true ? 'text-success' : 'text-danger'">
                    {{ data.item.active ? 'Aktivní' : 'Neaktivní' }}
                </span>
            </template>
            <template v-slot:cell(type)="data">
                {{ typeOfRepairType.getItem(data.item.type).text }}
            </template>
            <template v-slot:cell(commodity)="data">
                <i :class="commodity.getItem(data.item.commodity).icon"/>
                <span class="ml-2">{{ commodity.getItem(data.item.commodity).text }}</span>
            </template>
        </BTable>
        <div class="mt-3">
            <strong>Celkem záznamů:</strong> {{ totalRecords }}
        </div>

        <TablePaginator :total-records="totalRecords" :filter-request="filterRequest" hide-go-to-end-buttons/>

    </div>
</template>

<script>
import {mapGetters} from "vuex"
import SimpleFormRequest from "../../../../NewModel/Common/SimpleFormRequest"
import Commodity from "../../../../Model/Enum/commodity"
import TypeOfRepairType from "../../../../Model/Enum/type_of_repair_type"
import TableLoading from "@/Module/Common/UI/Table/TableLoading.vue"
import TablePaginator from "@/Module/Common/UI/Table/TablePaginator.vue"
import TableWithoutRecords from "@/Module/Common/UI/Table/TableWithoutRecords.vue"

export default {

    components: {
        TableLoading,
        TablePaginator,
        TableWithoutRecords,
    },

    data() {
        return {
            filterRequest: this.buildFilterRequest(),
            filterActive: false,
            fields: [
                {
                    key: 'name',
                    label: "Název",
                    sortable: true,
                    thClass: 'font-weight-700',
                    tdClass: 'align-middle',
                },
                {
                    key: 'shortName',
                    label: "Zkratka",
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle text-center w-10',
                },
                {
                    key: 'type',
                    label: "Typ opravy",
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle text-center w-15',
                },
                {
                    key: 'commodity',
                    label: "Komodita",
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle text-center w-15',
                },
                {
                    key: 'active',
                    label: "Stav",
                    sortable: true,
                    thClass: 'font-weight-700',
                    class: 'align-middle text-center w-10',
                },
                {
                    key: 'action',
                    label: "Akce",
                    thClass: 'font-weight-700',
                    class: 'text-right align-middle w-5',
                },
            ],
            commodity: Commodity,
            typeOfRepairType: TypeOfRepairType,
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/getUser',
            isLoading: 'repairType/isLoading',
            hasRecords: 'repairType/hasRepairTypes',
            records: 'repairType/getRepairTypes',
            totalRecords: 'repairType/getTotalRepairTypes',
        }),
        gridName: () => '_repairTypeGridFilter',
        isFilterUsed() {
            return this.filterRequest.filter.name !== ''
                || this.filterRequest.filter.type !== null
                || this.filterRequest.filter.commodity !== null
        },
    },

    created() {
        if (this.$cookies.isKey(this.gridName) && this.user.filterSave) {
            this.filterRequest = SimpleFormRequest.restore(this.$cookies.get(this.gridName))
        }
    },

    mounted() {
        this.filterUpdated()
    },

    methods: {

        buildFilterRequest() {
            return new SimpleFormRequest({
                name: "",
                type: null,
                commodity: null
            }, "name", 10, false)
        },

        gridUpdated(ctx) {
            if (ctx) {
                this.filterRequest.sortBy = ctx.sortBy
                this.filterRequest.sortDesc = ctx.sortDesc
                this.saveFilter()
            }
        },

        saveFilter() {
            if (this.user.filterSave) {
                this.$cookies.set(this.gridName, this.filterRequest.store())
            }
        },

        filterUpdated(resetPage = false) {
            if (resetPage) {
                this.filterRequest.currentPage = 1
            }
            this.saveFilter()
            this.$refs.table.refresh()
        },

        myProvider(ctx, callback) {
            let items = []
            this.$store.dispatch("repairType/clearAll")
            this.$store.dispatch("repairType/getFilteredRecords", this.filterRequest)
                .then((response) => {
                    callback(response)
                })
                .catch(() => {
                    callback([])
                })
            return items || []
        },

        resetFilters() {
            this.filterActive = false
            this.filterRequest = this.buildFilterRequest()
            this.filterUpdated()
        },

    },

}
</script>
